/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_OtherInputs */

const en_doc_type_other = /** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other Document`)
};

const id_doc_type_other = /** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen Lainnya`)
};

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const es_doc_type_other = en_doc_type_other;

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const fr_doc_type_other = en_doc_type_other;

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const de_doc_type_other = en_doc_type_other;

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const ja_doc_type_other = en_doc_type_other;

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const zh_doc_type_other = en_doc_type_other;

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const ar_doc_type_other = en_doc_type_other;

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const it_doc_type_other = en_doc_type_other;

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const ru_doc_type_other = en_doc_type_other;

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const pt_doc_type_other = en_doc_type_other;

/** @type {(inputs: Doc_Type_OtherInputs) => LocalizedString} */
const ko_doc_type_other = en_doc_type_other;

/**
* | output |
* | --- |
* | "Other Document" |
*
* @param {Doc_Type_OtherInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_other = /** @type {((inputs?: Doc_Type_OtherInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_OtherInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_other(inputs)
	if (locale === "es") return es_doc_type_other(inputs)
	if (locale === "fr") return fr_doc_type_other(inputs)
	if (locale === "de") return de_doc_type_other(inputs)
	if (locale === "ja") return ja_doc_type_other(inputs)
	if (locale === "zh") return zh_doc_type_other(inputs)
	if (locale === "ar") return ar_doc_type_other(inputs)
	if (locale === "id") return id_doc_type_other(inputs)
	if (locale === "it") return it_doc_type_other(inputs)
	if (locale === "ru") return ru_doc_type_other(inputs)
	if (locale === "pt") return pt_doc_type_other(inputs)
	return ko_doc_type_other(inputs)
});